export const formatCityState = value => value
    .charAt(0)
    .toUpperCase() + value.slice(1, -2) + value.slice(-2)
    .toUpperCase()
